import { useEffect, useState } from 'react';
import axios from 'axios';
import { DASH, authHeader } from '../api';
import { SectionCard, StatCard, Spinner, fmtMoney } from '../ui';
import { CalendarDays, CalendarRange, Calendar } from 'lucide-react';

const RevenueSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${DASH}/revenue?days=30`, { headers: authHeader() })
      .then((res) => mounted && setData(res.data))
      .catch(() => mounted && setError('Could not load revenue data.'))
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);

  if (loading) return <Spinner label="Loading revenue…" />;
  if (error) return <div className="text-sm text-red-700">{error}</div>;

  const rows = [
    { key: 'singles', label: 'Single Sessions' },
    { key: 'packs', label: '2-Session Packs' },
    { key: 'memberships', label: 'Memberships' },
  ];

  return (
    <div data-testid="wellness-admin-section-revenue" className="space-y-6">
      <div>
        <h2 className="text-2xl tracking-tight" style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 800, color: '#0d1f15' }}>
          Revenue
        </h2>
        <p className="text-sm text-[#5a7062] mt-1">Last 30 days, broken down by product.</p>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <StatCard testId="stat-revenue-day" label="Today" value={fmtMoney(data.day)} icon={Calendar} />
        <StatCard testId="stat-revenue-week" label="This Week" value={fmtMoney(data.week)} icon={CalendarDays} />
        <StatCard testId="stat-revenue-month" label="This Month" value={fmtMoney(data.month)} icon={CalendarRange} accent="#d97736" />
      </div>
      <SectionCard title="By Product" subtitle={`Rolling ${data.period_days}-day window`} testId="revenue-breakdown-card">
        <div className="space-y-3">
          {rows.map((r) => {
            const t = data.totals[r.key] || { revenue: 0, count: 0 };
            return (
              <div key={r.key} data-testid={`revenue-row-${r.key}`} className="flex items-center justify-between border-b border-[#f6f4ef] last:border-0 pb-3 last:pb-0">
                <div>
                  <div className="font-semibold text-[#0d1f15]">{r.label}</div>
                  <div className="text-xs text-[#5a7062]">{t.count} transactions</div>
                </div>
                <div className="text-lg font-bold" style={{ fontFamily: "'Manrope', sans-serif", color: '#1f3d2b' }}>{fmtMoney(t.revenue)}</div>
              </div>
            );
          })}
        </div>
      </SectionCard>
    </div>
  );
};

export default RevenueSection;
